import { render } from "./TitleArea.vue?vue&type=template&id=b7a57414&scoped=true"
import script from "./TitleArea.vue?vue&type=script&lang=js"
export * from "./TitleArea.vue?vue&type=script&lang=js"

import "./TitleArea.vue?vue&type=style&index=0&id=b7a57414&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7a57414"]])

export default __exports__